import { OnboardingForm } from '@/components/auth/OnboardingForm';
import { motion } from 'framer-motion';

export default function Login() {
  return (
    <div className="min-h-screen w-full bg-background flex flex-col lg:flex-row overflow-hidden relative">
      {/* Brutalist Background Text - Massive Scale */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none flex items-center justify-center opacity-[0.03] select-none">
        <h1 className="text-[25vw] font-black leading-none tracking-tighter">
          PORTAL
        </h1>
      </div>

      {/* Left Section: Branding & High Contrast (90/10 Tension) */}
      <div className="hidden lg:flex lg:w-[65%] bg-foreground items-end p-12 relative overflow-hidden">
        <motion.div 
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: "circOut" }}
          className="relative z-10"
        >
          <h2 className="text-primary text-[10vw] font-black leading-[0.85] tracking-tighter mb-4">
            LOGIN
          </h2>
          <div className="flex gap-4 items-center">
            <span className="w-20 h-1 bg-primary" />
            <p className="text-background/60 font-medium tracking-[0.2em] uppercase text-sm">
              LEILIZE Intelligence Platform
            </p>
          </div>
        </motion.div>

        {/* Decorative Graphic Element */}
        <div className="absolute top-12 left-12 w-32 h-32 border-l-2 border-t-2 border-primary/30" />
      </div>

      {/* Right Section: Authentic Form (Asymmetric focus) */}
      <div className="flex-1 flex flex-col justify-center p-6 sm:p-12 lg:p-20 relative z-20">
        <div className="max-w-md w-full mx-auto lg:mx-0">
          <motion.div
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="mb-12">
              <span className="text-primary font-bold text-xs uppercase tracking-[0.3em] block mb-4">
                Identificação Necessária
              </span>
              <h3 className="text-4xl font-heading font-bold text-foreground mb-4">
                Bem-vindo de volta.
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                Acesse sua conta para continuar suas simulações e gerenciar seus lances com IA.
              </p>
            </div>

            <div className="bg-card/50 backdrop-blur-sm p-2 rounded-lg border border-border/50">
              <OnboardingForm 
                initialMode="login" 
                redirectAfter="/userhome" 
              />
            </div>

            <div className="mt-12 flex items-center justify-between text-[10px] text-muted-foreground uppercase tracking-widest font-bold">
              <span>Secure Access</span>
              <span className="w-12 h-[1px] bg-border" />
              <span>LEILIZE System v2.0</span>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Mobile Header Branding */}
      <div className="lg:hidden absolute top-0 left-0 w-full p-6 flex justify-between items-center bg-background/80 backdrop-blur-md z-30 border-b border-border/50">
        <span className="text-primary font-black tracking-tighter text-2xl">LEILIZE</span>
        <div className="px-3 py-1 bg-primary text-white text-[10px] font-bold uppercase tracking-wider rounded">
          Login
        </div>
      </div>
    </div>
  );
}
